import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinsAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCoinsAdd"><Path d="M6.5 14C6.5 9.51385 9.9754 5.83942 14.3807 5.52222C13.0967 3.98095 11.1629 3 9 3C5.13401 3 2 6.13401 2 10C2 13.147 4.07675 15.809 6.93455 16.6903C6.65266 15.8448 6.5 14.9402 6.5 14Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15 21C18.866 21 22 17.866 22 14C22 10.134 18.866 7 15 7C11.134 7 8 10.134 8 14C8 17.866 11.134 21 15 21ZM15.75 11H14.25V13.25H12V14.75H14.25V17H15.75V14.75H18V13.25H15.75V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoinsAdd;
